import { section, color, align } from '@settings/common';

export function Schema({ article, blog, collection }) {
  if (article || blog || collection) return null;

  return {
    label: 'Testimonials',
    key: 'testimonials',
    fields: [
      {
        label: 'Text Settings',
        name: 'text',
        description: 'Heading, alignment',
        component: 'group',
        fields: [
          {
            label: 'Heading',
            name: 'heading',
            component: 'markdown',
            defaultValue: '## Over 30,000 5-Star Reviews',
          },
          {
            name: 'textAlign',
            label: 'Text align',
            component: 'radio-group',
            direction: 'horizontal',
            variant: 'radio',
            options: align.options,
            defaultValue: align.value.center,
          },
        ],
      },
      {
        label: 'Display Settings',
        name: 'display',
        description: 'Star rating display options',
        component: 'group',
        fields: [
          {
            name: 'showStars',
            label: 'Show Star Rating',
            component: 'toggle',
            description: 'Display 5-star rating above each testimonial',
            toggleLabels: {
              true: 'Show',
              false: 'Hide',
            },
            defaultValue: true,
          },
        ],
      },
      {
        name: 'testimonials',
        label: 'Testimonials',
        description:
          'Max of 3 testimonials. If less than 3 are populated, tiles will center',
        component: 'group-list',
        itemProps: {
          label: '{{item.reviewerName}}',
        },
        defaultItem: {
          reviewText:
            "This is the best cup I have ever purchased. Absolutely my new favorite. I love that it doesn't leak and keeps my drinks hot or cold.",
          reviewerName: 'Customer Name',
        },
        validate: {
          maxItems: 3,
        },
        fields: [
          {
            name: 'reviewText',
            label: 'Review Text',
            component: 'textarea',
            description: 'The testimonial review text',
          },
          {
            name: 'reviewerName',
            label: 'Reviewer Name',
            component: 'text',
            description: 'Name of the person giving the review',
          },
        ],
        defaultValue: [
          {
            reviewText:
              "This is the best cup I have ever purchased. Absolutely my new favorite. I love that it doesn't leak and keeps my drinks hot or cold.",
            reviewerName: 'Christyal P.',
          },
          {
            reviewText:
              "This was my first Brümate and I absolutely fell in love. It fit in my cup holders nicely and I haven't had any spills. Also, love the color!",
            reviewerName: 'Paige D.',
          },
          {
            reviewText:
              "I love the way it can be sealed and doesn't leak. I laid it in my purse and had no fear of it getting anything wet. I would definitely buy it again.",
            reviewerName: 'Rebecca H.',
          },
        ],
      },
      {
        ...section,
        defaultValue: {
          bgColor: color.value.background,
          color: color.value.text,
          desktop: {
            container: 'container',
            mt: 'none',
            py: 'xl',
          },
          mobile: {
            container: 'container',
            mt: 'none',
            py: 'l',
          },
        },
      },
    ],
  };
}
